/* Copyright (c) 2025 MOCA Systems, Inc.  All rights reserved. */
import { Component } from '@appCanvasCommon/component-system/Component';
import { ComponentInterface } from '@appCanvasCommon/interfaces/component.interface';
import { CanvasAngularLand } from '../../../../app-data/interfaces/canvas-angular-land';
import { AbstractApplication } from '@appCanvasCommon/core/AbstractApplication';
import { Container } from 'pixi.js-legacy';
import { LayerPaths } from '@appPlanApplication/LayerPaths';
/**
 * This export component hides the root today line node when the lightbox is first created
 */
export class HideTodayLine extends Component implements ComponentInterface {
	/**
	 * Invoked once the lightbox is first created
	 * @param canvasAngularLand
	 * @param application
	 */
	public onExportPreviewStarted(
		canvasAngularLand: CanvasAngularLand,
		application: AbstractApplication
	): void {
		const todayLineLayer: Container | null = application.layerManager.getLayer(
			LayerPaths.BACKGROUND_TIMELINE_TODAY_LINE
		);
		if (todayLineLayer) {
			todayLineLayer.visible = false;
			todayLineLayer.renderable = false;
		}
	}
	/**
	 * Invoked once the export is finished. This turns the today line back on
	 * @param canvasAngularLand
	 * @param application
	 */
	public onExportPreviewClosed(canvasAngularLand: CanvasAngularLand, application: AbstractApplication): void {
		const todayLineLayer: Container | null = application.layerManager.getLayer(
			LayerPaths.BACKGROUND_TIMELINE_TODAY_LINE
		);
		if (todayLineLayer) {
			todayLineLayer.visible = true;
			todayLineLayer.renderable = true;
		}
	}
}
